import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  useMediaQuery,
  useTheme,
  Container,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Grid,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../../assets/nw/cropped-Untitled-design-5.png";
import RedeemIcon from "@mui/icons-material/Redeem";
import EmojiFoodBeverageIcon from "@mui/icons-material/EmojiFoodBeverage";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { useNavigate, useLocation } from "react-router-dom";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import MenuOpenRoundedIcon from "@mui/icons-material/MenuOpenRounded";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import qrImage from "../../assets/nw/qr-code.png";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const menuItems = [
  {
    label: "Home",
    icon: <AllInclusiveIcon sx={{ color: "#ff8c31" }} />,
    path: "/",
  },
  {
    label: "E Broucher",
    icon: <RedeemIcon sx={{ color: "#ff8c31" }} />,
    path: "/e-brochure",
  },
  {
    label: "About Us",
    icon: <EmojiFoodBeverageIcon sx={{ color: "#ff8c31" }} />,
    path: "/about-us",
  },
  {
    label: "Our Projects",
    icon: <LocalGroceryStoreIcon sx={{ color: "#ff8c31" }} />,
    path: "/our-project",
  },
  {
    label: "Membership Registration",
    icon: <ShoppingBagOutlinedIcon sx={{ color: "#ff8c31" }} />,
    path: "/membership-registration",
  },
];

const HeaderSec = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [infoDrawerOpen, setInfoDrawerOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const toggleInfoDrawer = (open) => () => {
    setInfoDrawerOpen(open);
  };

  return (
    <Box
      component="header"
      sx={{
        position: "static",
        backgroundColor: "transparent",
        maxWidth: "1200px",
        mx: "auto",
        py: 0.5,
      }}
    >
      <Container maxWidth="xl">
        <Grid container alignItems="center" justifyContent="space-between">
          {/* ✅ Mobile Header */}
          {isMobile ? (
            <>
              <Grid item xs={12}>
                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                >
                  {/* Logo */}
                  <Grid item>
                    <Box
                      component="img"
                      src={logo}
                      alt="anveshan"
                      sx={{
                        height: 80,
                        maxWidth: "100%",
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate("/")}
                    />
                  </Grid>

                  {/* Menu Icon */}
                  <Grid item>
                    <IconButton
                      onClick={toggleDrawer(true)}
                      sx={{ color: "#000" }}
                    >
                      <MenuIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>

              {/* ✅ Mobile Drawer */}
              <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
              >
                <Box sx={{ width: 280 }}>
                  {/* Drawer Header */}
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    p={2}
                    sx={{ borderBottom: "1px solid #ddd" }}
                  >
                    <Grid item>
                      <IconButton onClick={toggleDrawer(false)}>
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                  </Grid>

                  {/* Menu List */}
                  <List>
                    {menuItems.map((item, index) => {
                      const isActive = location.pathname === item.path;
                      return (
                        <ListItem
                          button
                          key={index}
                          onClick={() => {
                            navigate(item.path);
                            setDrawerOpen(false);
                          }}
                          sx={{
                            px: 3,
                            position: "relative",
                            "&:hover .underline": {
                              width: "100%",
                            },
                          }}
                        >
                          {item.icon}
                          <ListItemText
                            primary={item.label}
                            sx={{
                              ml: 2,
                              position: "relative",
                              "& .underline": {
                                position: "absolute",
                                bottom: -2,
                                left: 0,
                                height: "2px",
                                width: isActive ? "100%" : "0%",
                                backgroundColor: "#17666f",
                                transition: "width 0.3s ease",
                              },
                            }}
                            primaryTypographyProps={{
                              fontSize: 16,
                              fontWeight: isActive ? 600 : 400,
                              color: isActive ? "#17666f" : "#000",
                            }}
                          >
                            <span className="underline"></span>
                          </ListItemText>
                        </ListItem>
                      );
                    })}

                    {/* ✅ Contact Us Button inside Drawer */}
                    <Box
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                      onClick={() => {
                        navigate("/contact-us");
                        setDrawerOpen(false);
                      }}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "20px auto",
                        width: "85%",
                        padding: "8px 14px",
                        background:
                          "linear-gradient(to right, #18666f, #085b66)",
                        color: "#fff",
                        fontWeight: 500,
                        borderRadius: "25px",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                          zIndex: 1,
                          transition: "text-transform 0.3s ease",
                        }}
                      >
                        {hovered ? "contact Us" : "Contact Us"}
                      </Typography>

                      {/* Icon Animation */}
                      <Box
                        sx={{
                          position: "relative",
                          width: "30px",
                          height: "30px",
                          marginLeft: "10px",
                          overflow: "hidden",
                        }}
                      >
                        <Box
                          sx={{
                            position: "absolute",
                            top: hovered ? "-100%" : "0%",
                            left: 0,
                            opacity: hovered ? 0 : 1,
                            transform: "rotate(30deg)",
                            transition: "all 0.3s ease",
                            backgroundColor: "#fff",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                          }}
                        >
                          <ArrowUpwardIcon
                            sx={{ fontSize: "18px", color: "#000" }}
                          />
                        </Box>

                        <Box
                          sx={{
                            position: "absolute",
                            top: hovered ? "0%" : "100%",
                            left: 0,
                            opacity: hovered ? 1 : 0,
                            transform: "rotate(30deg)",
                            transition: "all 0.3s ease",
                            backgroundColor: "#e6f0f5",
                            width: "30px",
                            height: "30px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "50%",
                          }}
                        >
                          <ArrowUpwardIcon
                            sx={{ fontSize: "18px", color: "black" }}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </List>
                </Box>
              </Drawer>
            </>
          ) : (
            <>
              {/* ✅ Desktop Header */}
              <Grid item>
                <Box
                  component="img"
                  src={logo}
                  alt="anveshan"
                  sx={{
                    cursor: "pointer",
                    maxWidth: "100%",
                    height: 80,
                    objectFit: "cover",
                  }}
                  onClick={() => navigate("/")}
                />
              </Grid>

              {/* Menu Items */}
              <Grid item>
                <Grid container spacing={4}>
                  {menuItems.map((item) => {
                    const isActive = location.pathname === item.path;
                    return (
                      <Grid item key={item.label}>
                        <Typography
                          sx={{
                            fontSize: 18,
                            color: isActive ? "#17666f" : "#222",
                            borderBottom: isActive
                              ? "2px solid #17666f"
                              : "2px solid transparent",
                            transition: "border-bottom 0.3s ease",
                            cursor: "pointer",
                            "&:hover": {
                              borderBottom: "2px solid #17666f",
                            },
                          }}
                          onClick={() => navigate(item.path)}
                        >
                          {item.label}
                        </Typography>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>

              {/* ✅ Right Side: Contact Us Button + Info Drawer Icon */}
              <Grid item sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box
                  component="a"
                  href="/contact-us"
                  aria-label="Contact us"
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "8px 14px",
                    background: "linear-gradient(to right, #18666f, #085b66)",
                    color: "#fff",
                    fontWeight: 500,
                    borderRadius: "25px",
                    textDecoration: "none",
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      zIndex: 1,
                      transition: "text-transform 0.3s ease",
                    }}
                  >
                    {hovered ? "contact Us" : "Contact Us"}
                  </Typography>

                  {/* Icon Animation */}
                  <Box
                    sx={{
                      position: "relative",
                      width: "30px",
                      height: "30px",
                      marginLeft: "10px",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        position: "absolute",
                        top: hovered ? "-100%" : "0%",
                        left: 0,
                        opacity: hovered ? 0 : 1,
                        transform: "rotate(30deg)",
                        transition: "all 0.3s ease",
                        backgroundColor: "#fff",
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                      }}
                    >
                      <ArrowUpwardIcon
                        sx={{ fontSize: "18px", color: "#000" }}
                      />
                    </Box>

                    <Box
                      sx={{
                        position: "absolute",
                        top: hovered ? "0%" : "100%",
                        left: 0,
                        opacity: hovered ? 1 : 0,
                        transform: "rotate(30deg)",
                        transition: "all 0.3s ease",
                        backgroundColor: "#e6f0f5",
                        width: "30px",
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                      }}
                    >
                      <ArrowUpwardIcon
                        sx={{ fontSize: "18px", color: "black" }}
                      />
                    </Box>
                  </Box>
                </Box>

                {/* Info Drawer Icon */}
                {/* <IconButton
                  onClick={toggleInfoDrawer(true)}
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                >
                  {hover ? (
                    <MenuOpenRoundedIcon sx={{ color: "#17666f" }} />
                  ) : (
                    <MenuRoundedIcon sx={{ color: "#17666f" }} />
                  )}
                </IconButton> */}
              </Grid>

              {/* Info Drawer */}
              {/* <Drawer
                anchor="right"
                open={infoDrawerOpen}
                onClose={toggleInfoDrawer(false)}
              >
                <Box
                  sx={{
                    width: 340,
                    py: 6,
                    px: 4,
                    backgroundColor: "#0b0b0b",
                    color: "#fff",
                    textAlign: "left",
                    overflowY: "auto",
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": { display: "none" },
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "1.125rem",
                      mb: 2,
                    }}
                  >
                    ABOUT US
                  </Typography>

                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 600,
                      color: "#78787f",
                      mb: 1,
                    }}
                  >
                    NAVA KARNATAKA NIRMANA & OTHERS HOUSING WELFARE TRUST
                  </Typography>

                  <Typography
                    sx={{
                      color: "#78787f",
                      lineHeight: 1.8,
                      fontSize: 16.5,
                      mb: 4,
                    }}
                  >
                    Provides an opportunity of owning a dream piece of land in
                    Bengaluru’s fastest growing area. It’s the kind of life you
                    can indeed build your future on. Value is our core
                    philosophy in achieving the goal and providing value for
                    money. With a sizable township to be built in the rapidly
                    developing Bangalore region.
                  </Typography>

                  <Typography
                    variant="caption"
                    display="block"
                    align="center"
                    sx={{ color: "#bfbfbf", mb: 1 }}
                  >
                    Scan the code
                  </Typography>

                  <Box
                    component="img"
                    src={qrImage}
                    alt="QR Code"
                    sx={{
                      display: "block",
                      mx: "auto",
                      width: 180,
                      height: 180,
                      borderRadius: 2,
                      p: 1,
                      backgroundColor: "#00bfa5",
                    }}
                  />

                  <Box
                    sx={{ display: "flex", justifyContent: "center", mt: 3 }}
                  >
                    <Button
                      variant="contained"
                      startIcon={
                        <WhatsAppIcon
                          sx={{ width: 24, height: 24, color: "white" }}
                        />
                      }
                      sx={{
                        backgroundColor: "#25d366",
                        textTransform: "none",
                        fontWeight: 600,
                        fontSize: 16,
                        px: 3.5,
                        py: 2,
                        borderRadius: "30px",
                        "&:hover": {
                          backgroundColor: "#1ebe5d",
                        },
                      }}
                      href="https://wa.me/919876543210"
                      target="_blank"
                    >
                      Chat with us!
                    </Button>
                  </Box>
                </Box>
              </Drawer> */}
            </>
          )}
        </Grid>
      </Container>
    </Box>
  );
};

export default HeaderSec;
